// import ButtonBase from "@material-ui/core/ButtonBase";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { di } from "../../../bottle";
import { InfoCard, Text } from "../../../components";

// class definition
export class BikeCard extends Component {
  static propTypes = {
    style: PropTypes.any,
    title: PropTypes.string.isRequired,
    price: PropTypes.string,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    asset: PropTypes.any.isRequired,
    onPressButton: PropTypes.func,
  };

  static defaultProps = {
    show: false,
    title: "Title",
    price: "No price available",
    subtitle: "Subtitle",
    description: "Description",
    asset: require("../assets/ryker-600.png"),
    onPressButton: () => undefined,
  };

  constructor(props) {
    // call base
    super(props);

    // initialize instance variables
    this.container = null;

    // initialize state
    this.state = {
      showInfo: false,
    };
  }

  onPressInfo = () => {
    this.setState({
      showInfo: true,
    });
  };

  onCloseInfo = () => {
    this.setState({
      showInfo: false,
    });
  };

  render() {
    // resolve properties
    const {
      title,
      price,
      description,
      asset,
      onPressButton,
      background,
      subtitle,
      isExcluded,
    } = this.props;

    let priceString = "";

    let model;
    let engine;

    const splitTitle = title.split("|");
    if (splitTitle.length > 0) {
      model = splitTitle[0].toUpperCase() + " ";
      engine = splitTitle[1];
    } else {
      model = splitTitle[0].toUpperCase();
      engine = "";
    }

    if (price) {
      const localizedPrice = di.profileManager.localizePrice(price, true);
      const currency = di.profileManager.currency;
      if (
        di.profileManager.region === "DE" ||
        di.profileManager.region === "FR"
      ) {
        priceString = di.localization.get(
          "selection.startingAt",
          localizedPrice,
          ""
        );
      } else {
        priceString = di.localization.get(
          "selection.startingAt",
          localizedPrice,
          currency
        );
      }
    }

    // render view
    return (
      <div style={styles.container}>
        <InfoCard
          style={{ padding: styles.infoContainer.padding }}
          show={this.state.showInfo}
          title={title}
          priceString={priceString}
          description={description}
          onClose={this.onCloseInfo}
          isExcluded={isExcluded}
        />
        <img
          src={asset}
          alt={"bike"}
          style={styles.image}
          onClick={!isExcluded && onPressButton}
        />
        <img
          src={background}
          alt={"background"}
          style={styles.background}
          onClick={!isExcluded && onPressButton}
        />
        <div style={styles.infoContainer}>
          {" "}
          <button onClick={this.onPressInfo} style={styles.infoIcon}>
            <img
              src={require("../../../assets/images/btn-info.png")}
              alt={"icon"}
            />
          </button>
          <div style={{ zIndex: 5 }}>
            {" "}
            <div style={styles.titleContainer}>
              <Text style={styles.title} bold>
                {model}
              </Text>
              <Text style={styles.engineName} bold>
                {engine}
              </Text>
            </div>
            {!isExcluded && <Text style={styles.price} bold uppercase>
              {priceString}
            </Text>}
            <Text style={styles.subtitle}>{subtitle}</Text>
          </div>
        </div>
        {
          <button
            onClick={onPressButton}
            style={isExcluded ? styles.excludedButton : styles.selectButton}
            disabled={isExcluded}
          >
            <Text
              style={isExcluded ? styles.excludedText : styles.buttonText}
              bold
              uppercase
            >
              {isExcluded
                ? di.localization.get("selection.excludedBikeText")
                : di.localization.get("selection.button")}
            </Text>
          </button>
        }
      </div>
    );
  }
}

const styles = {
  container: {
    position: "relative",
    background: "#333333",
    width: "43vw",
    height: "20vw",
    zIndex: 1,
    borderRadius: ".5vw",
  },

  image: {
    position: "absolute",
    bottom: 0,
    left: "-1.31vw",
    width: "16.9vw",
    zIndex: 3,
  },
  background: {
    position: "absolute",
    top: "1.31vw",
    left: "-1.31vw",
    width: "21.37vw",
    zIndex: 2,
    webkitMaskImage: "linear-gradient(to left, transparent 5%, black 65%)",

    borderRadius: ".25vw",
  },
  infoContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    paddingTop: "2vw",
    paddingLeft: "17vw",
    zIndex: 5,
  },
  titleContainer: { display: "flex", paddingBottom: "1vw" },
  title: {
    alignSelf: "flex-end",
    textShadow: "0 .4vw .4vw rgba(0, 0, 0, 0.51)",
    fontSize: "1.7vw",
    fontWeight: "800",
    color: "#ffffff",
    paddingTop: "1.5vw",
    zIndex: 5,
  },
  engineName: {
    alignSelf: "flex-end",
    textShadow: "0 .4vw .4vw rgba(0, 0, 0, 0.51)",
    fontSize: "1vw",
    fontWeight: "800",
    color: "#ffffff",
    paddingLeft: ".5vw",
    paddingBottom: ".25vw",
    zIndex: 5,
  },
  price: {
    textShadow: "0 .4vw .4vw rgba(0, 0, 0, 0.51)",
    fontSize: ".8vw",
    fontWeight: "300",
    fontStyle: "italic",
    color: "#ffffff",
    zIndex: 5,
    paddingBottom: "1vw",
  },

  subtitle: {
    fontSize: ".87vw",
    fontWeight: "300",
    lineHeight: "1.35",
    color: "#ffffff",
    zIndex: 5,
    paddingRight: "1vw",
  },

  infoIcon: {
    alignSelf: "flex-end",
    marginRight: "1.3vw",
    width: "1.68vw",
    height: "1.88vw",
    objectFit: "contain",
  },

  selectButton: {
    position: "absolute",
    bottom: "1.7vw",
    right: "1.7vw",
    textAlign: "center",
    margin: "0px 0 0px 8.73vw",
    width: "15.75vw",
    height: "2.85vw",
    borderRadius: ".25vw",
    boxShadow:
      "0 .52vw .52vw 0 rgba(0, 0, 0, 0.24), 0 0 .52vw 0 rgba(0, 0, 0, 0.12)",
    border: "solid .13vw #ffd200",
    zIndex: 5,
  },
  excludedButton: {
    position: "absolute",
    bottom: "1.7vw",
    right: "1.7vw",
    textAlign: "center",
    margin: "0px 0 0px 8.73vw",
    width: "15.75vw",
    height: "2.85vw",
    zIndex: 5,
  },
  buttonText: {
    textShadow: "0 .13vw .52vw rgba(0, 0, 0, 0.6)",
    fontSize: ".87vw",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: " normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#ffffff",
    zIndex: 5,
  },

  excludedText: {
    textShadow: "0 .13vw .52vw rgba(0, 0, 0, 0.6)",
    fontSize: "1.01vw",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: " normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#ffffff",
    zIndex: 5,
  },
};



// WEBPACK FOOTER //
// ./src/pages/Selection/components/BikeCard.js